const components = {};

const importCompontents = () => {
    const pages = require.context('.', true, /^((?!Base|Edit).)*\.vue$/);

    pages.keys().forEach(filePath => {
        const urlPieces = filePath.split('/');
        const componentName = urlPieces.pop().split('.')[0];
        urlPieces.splice(0, 1);

        const componentUrl = `${urlPieces.join('/')}/${componentName}`;

        components[componentName] = () =>
            import(`@/components/contents/${componentUrl}`);
    });
};

importCompontents();

export default components;
